import type { ActiveLoan, LoanProvider } from "~/graphql/client"
import { LoanProvider as LoanProviderEnum } from "~/graphql/client"
import { FinanceType } from "~/utils/finance/constants"

/**
 * Finds the active loan that matches the selected loan provider.
 *
 * Falls back to a finance-type-specific provider when the selected quote was
 * deleted, and finally to the lone active loan when there is only one.
 */
export const getActiveLoanForProvider = (
  activeLoans: ActiveLoan[] | null | undefined,
  selectedLoanProvider: keyof typeof LoanProvider | undefined,
  financeType?: FinanceType | string | null,
): ActiveLoan | undefined => {
  if (!activeLoans?.length) {
    return undefined
  }

  if (selectedLoanProvider) {
    return activeLoans.find((loan) => loan.provider === selectedLoanProvider)
  }

  if (financeType === FinanceType.CONCERT) {
    return activeLoans.find((loan) => loan.provider === LoanProviderEnum.concert)
  }

  if (financeType === FinanceType.LIGHT_REACH) {
    return activeLoans.find(
      (loan) => loan.provider === LoanProviderEnum.lightreach,
    )
  }

  if (activeLoans.length === 1) {
    return activeLoans[0]
  }

  return undefined
}
